<template>
  <component
    :is="as"
    class="jade-group-header"
  >
    <component
      :is="computedRenderElement"
      :class="computedClassContainer"
      type="button"
      v-on="$listeners"
    >
      <div class="jade-group-header__content">
        <jade-text
          :variant="computedVariant"
          :color="computedColor"
        >
          <template v-if="title">{{ title }}</template>
          <slot v-else></slot>
        </jade-text>
      </div>
      <div>
        <jade-icon
          v-if="isInteractive"
          size="medium"
          color="low"
          use="chevron-right"
        />
        <slot name="trailing"></slot>
      </div>
    </component>
  </component>
</template>

<script>
import JadeText from '../JadeText'
import JadeIcon from '../JadeIcon'

export default {
  name: 'JadeGroupHeader',

  components: {
    JadeText,
    JadeIcon
  },

  props: {
    title: String,
    as: {
      type: String,
      default: 'header'
    },
    variant: {
      type: String,
      default: 'heading',
      validation: v => ['heading', 'overline'].includes(v)
    }
  },

  computed: {
    isInteractive () {
      return this.$listeners?.click
    },
    isHeading () {
      return this.variant === 'heading'
    },
    computedVariant () {
      return this.isHeading ? 'heading-xsmall' : 'overline'
    },
    computedColor () {
      return this.isHeading ? 'high' : 'medium'
    },
    computedRenderElement () {
      return this.isInteractive ? 'button' : 'div'
    },
    computedClassContainer () {
      return {
        'jade-group-header__container': true,
        'is-interactive': this.isInteractive
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/group-header.css';
</style>
